import './DorpwoncustomStyle.css'

import React, { useEffect, useRef, useState } from 'react'

const Dorpwoncustom = ({placeholder, value, options, onChange }) => {

    const [isActive, setIsActive] = useState();
    const ref = useRef();

    useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setIsActive(false);
          }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);

    return (
        <div className={`CustomDropdownmain  ${isActive && "active"}`} ref={ref}>
            <div className="dropdownselect flex-between" onClick={() => setIsActive(!isActive)}>
                <span className='text3'>{value ? options?.find(item => item?.value === value)?.label : placeholder}</span>
                <img src="/assets/img/arrow-down2.png" alt="" className='downarrow' />
            </div>
            <div className="ListthatSelected">
                <ul className='listwrapfordropdown'>
                    {
                        options.map((item, index) =>
                            <li className='text3' key={index} onClick={() => {onChange(item?.value); setIsActive(false)}}>{item?.label}</li>
                        )
                    }
                </ul>
            </div>
        </div>
    )
}

export default Dorpwoncustom